<template>
  <div>
    <iframe id="doxy" class="scroll-nuevo" src="https://neumomed.doxy.me/"></iframe>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  #doxy{
height: 100vh;
width: 100vw;
border:none
  }
</style>


// WEBPACK FOOTER //
// src/components/HistoriaClinicaV3.vue